<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getDomainList, getCheck, getUser } from "@/service/getData";
import { mapMutations } from "vuex";
export default {
    name: "App",
    created() {
		// this.getCheck()
		this.getDomainList()
		// this.getUser()
    },
    methods: {
		/**
		 * @author wuweihong
		 * @description 校验是否是当前登录人的个人中心
		 */
		getCheck () {
			let params = {
				employeeId: this.$route.query.ownerId?this.$route.query.ownerId: ''
			}
			getCheck(params).then(res => {
				if (res.data) {
					this.getDomainList()
					this.setOwner(res.data)
				} else {
					this.$router.push({name:'personal'})
				}
			})
		},
		// Vuex存储域名跳转
		...mapMutations({
				setJumplink: "SET_JUMPLINK",
				setOwner: "SET_OWNER",
				setUserInfo:"SET_USER_INFO",
		}),
		// 获取域名跳转列表
		getDomainList() {
			getDomainList().then(res => {
				if (res.data) {
					this.setJumplink(res.data)
					localStorage.setItem("jumplink",JSON.stringify(res.data))
					localStorage.setItem("_jumplink",JSON.stringify(res.data))
				}
			})
		}
    }
}
</script>

<style>
html,body{ 
		height: 100%;
		overflow-x: hidden;
	}
	#app{
		height: 100%;
	}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.gw-messageBox, .el-message-box__wrapper {
	z-index: 99999 !important;
}
</style>
<style lang='scss'>
.gw-messageBox {
  .el-message-box__header {
     background-color: #0698dd !important;
   }
}
.gw-messageBox-warning {
  .el-message-box__header {
    background-color: #ffeb3b !important;
  }
}
.gw-messageBox,.gw-messageBox-warning {
  position: relative;
  width:480px !important;
  height: 200px !important;
  border:none !important;
  border-radius: 0px !important;
  .el-message-box__header {
    padding:0 !important;
    height:5px;
    line-height:5px;
  }
  .el-message-box__content{
    padding: 20px 40px 20px 40px !important;
    margin-bottom: -65px;
  }
  .gw-messagebox-error {
    display: flex;
    align-items: center;
    position: relative;
  img {
    width:140px;
    height:140px;
  }
  span {
    padding-left:20px;
    font-size:16px;
    padding-bottom: 45px;
    display: inline-block;
    text-align: left;
  }
}
  .el-message-box__btns {
    text-align: right;
    right: 45px;
    position: absolute;
    .gw-messageBox-button {
      color: #0698dd !important;
      background-color: #FFF !important;
      border-color: #0698dd !important;
      padding: 9px 30px;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue